import * as React from 'react';
type IconToolsProps = React.SVGProps<SVGSVGElement>;

export const IconTools: React.FC<IconToolsProps> = (props) => (
	<svg
		width={16}
		height={16}
		viewBox="0 0 16 16"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}>
	<rect y="8.88879" width="7.11111" height="7.11111" rx="2" fill="#425563"/>
	<rect x="8.88892" y="8.88879" width="7.11111" height="7.11111" rx="2" fill="#425563"/>
	<rect x="8.88892" width="7.11111" height="7.11111" rx="2" fill="#425563"/>
	<path d="M6.75658 0.988712C7.19621 1.38394 7.23173 2.05449 6.83651 2.49412L3.63918 6.04671C3.44379 6.26431 3.16846 6.39309 2.87538 6.39753C2.58229 6.40197 2.30252 6.29095 2.09381 6.08668L0.313072 4.31038C-0.104357 3.89295 -0.104357 3.21796 0.313072 2.80497C0.730501 2.39198 1.40549 2.38754 1.81848 2.80497L2.79988 3.78638L5.24673 1.06865C5.64195 0.629013 6.3125 0.593487 6.75214 0.988712H6.75658Z" fill="#425563"/>
	</svg>

);
export default IconTools;
